//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 20.08.2015.
 */

(function () {

    angular
        .module('container.components')
        .directive('srsngSearch', srsngSearch);

    function srsngSearch() {
        return {
            restrict: 'E',
            scope: { visible: '=' },
            templateUrl: 'container/ui/app/components/search/search.html',
            controller: controller,
            link: link
        };

        function link(scope, element, attrs) {

            scope.$watch('visible', function (newValue, oldValue) {
                if (!newValue) scope.openActionMenu = '';
                scope.prevRowIndex = '';
            });

            function searchClickCaptured(event) {
                if ((event.target.id).indexOf('actionMenuButton') == -1) scope.toggleActionMenu('', '', '');
            }


        }

        function controller($scope, $compile, MockDevices, MockEvents, MockRules, $sce) {
            $scope.expandedCategory = '';
            $scope.openActionMenu = '';
            $scope.categories = {
                searchInput:'',
                buckets:[
                    {
                        id:1,
                        title:'Device Models',
                        resource:MockDevices,
                        items:[]
                    },
                    {
                        id:2,
                        title:'Events',
                        resource:MockEvents,
                        items:[]
                    },
                    {
                        id:3,
                        title:'Rules',
                        resource:MockRules,
                        items:[]
                    }
                ]
            };



            $scope.addOrRemoveFilter = function(category) {
                $scope.expandedCategory = ($scope.expandedCategory == category.id)?'':category.id;
            };


            $scope.highlight = function(text) {
                if (!$scope.categories.searchInput) {
                    return $sce.trustAsHtml(text);
                }
                return $sce.trustAsHtml(text.replace(new RegExp($scope.categories.searchInput, 'gi'), '<span class="highlighted">$&</span>'));
            };


            $scope.getSearchResults = function () {
                _.each($scope.categories.buckets, function(category) {
                    category.items = category.resource.query({text:$scope.categories.searchInput});
                });
            };


            $scope.toggleActionMenu = function (rowIndex, categoryId, resultIndex) {
                $scope.openActionMenu = ($scope.openActionMenu != rowIndex)?rowIndex:'';


                if ($scope.prevRowIndex) {
                    var tmp = angular.element('#actionMenuPopup-' + $scope.prevRowIndex);
                    if (tmp[0]) {
                        tmp[0].attributes.getNamedItem('visible').value = false;
                        tmp.remove();
                    }

                    $scope.prevRowIndex = '';
                }

                if ($scope.openActionMenu) {
                    var actions = $scope.categories.buckets[categoryId-1].items[resultIndex].actions;
                    var items = "";
                    for (var i=0;i<actions.length;i++) {
                        items = items + '<div class="item"><a href="' + actions[i].url + '">' + actions[i].title + '</a></div>';
                    }

                    var el = $compile('<srsng-popup '
                        + 'class="tab-action-menu-popup" '
                        + 'visible="true" '
                        + 'id="actionMenuPopup-' + rowIndex + '" '
                        + 'target="#actionMenuButton-' + rowIndex + '" '
                        + 'anchor="left center" align="right center" offset="-5 0" arrow="right-alt" '
                        + 'remove-on-hide hide-on-parent-scroll>' +
                        '<div class="action-menu">' +
                        '<div class="list-light">' +
                        items +
                        '</div>' +
                        '</div>' +
                        '</srsng-popup>')($scope);

                    el.insertAfter('#actionMenuButton-' + rowIndex);

                    $scope.prevRowIndex = rowIndex;
                }
            };

            $scope.getActionMenuButton = function(rowIndex, categoryId, resultIndex) {
                $("#actionMenu-" + rowIndex).html(
                    $compile('<a href="javascript:;"><div id="actionMenuButton-' + rowIndex +
                        '" class="action-menu-button" ' +
                        ' ng-include="\'container/ui/assets/img/icons/system-icons-16x16/system-ic-action-16x16.svg\'"' +
                        ' ng-click="toggleActionMenu(' + rowIndex + ', ' + categoryId + ', ' + resultIndex +
                        ')"></div></a>')($scope)
                );

            };



        }

    }

}());

